import React from 'react';
import './WhatsAppButton.css';
import { WhatsAppIcon } from './Icons';

function WhatsAppButton() {
    const phoneNumber = '212632466957';
    const message = encodeURIComponent('Hello, I am interested in your products!');

    return (
        <a
            href={`https://wa.me/${phoneNumber}?text=${message}`}
            className="whatsapp-float-container"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
        >
            <span className="whatsapp-label">Chat with us</span>
            <div className="whatsapp-icon-wrapper">
                <WhatsAppIcon />
                <div className="pulse-ring"></div>
            </div>
        </a>
    );
}

export default WhatsAppButton;
